<template lang="pug">
//- 點數購買紀錄
.record-buy-tab-four-view
  table.record-buy-table
    thead
      tr
        th.row-1 交易ID
        th 交易時間
        th 點數方案
        th 方案名稱
        th.text-align-center 交易金額
    tbody
      tr(v-if="plans.length === 0")
        td.text-align-center(colspan="5") 目前無購買紀錄
      tr(v-for="(plan, index) in plans")
        td.row-1 
        td {{ plan.time }}
        td 
        td {{ trade.tradeDescribe }}
        td.text-align-center
          span +{{ plan.point }}
  .list-bottom(v-if="plans.length !== 0")
    nav
      ul.pagination.pagination-rounded
        li.disabled(v-if="page > 1")
          a(@click="jumpList(page, 1)", aria-label="Previous")
            i.fa.fa-chevron-left.first

        li(
          v-for="pre_page in totalPage",
          v-if="pre_page < page + 4 && pre_page > page - 4",
          :class="page == pre_page ? 'active' : ''"
        )
          a(@click="jumpList(pre_page)")
            | {{ pre_page }}

        li(v-if="page < totalPage")
          a(@click="jumpList(page, 2)", aria-label="Next")
            i.fa.fa-chevron-right.last
</template>

<script>
export default {

  data () {
    return {
      page: 1,
      totalPage: 0,
      plans: []
    }
  },
  watch: {

  },
  created () {
    this.totalPage = Math.ceil(this.plans.length / 10)
    // this.getStudentPointPlansLogs()
  },
  methods: {
    //- 跳頁
    jumpList (_page = '', _opt = '') {
      if (_page) {
        this.page = (_page)
      }
      if (_opt === 1) {
        this.page = this.page - 1
      }
      if (_opt === 2) {
        this.page = this.page + 1
      }
      this.goTop()
    },
    goTop () {
      this.$emit('goTop')
    }
    // 獲得學員點數交易資料
    // async getStudentPointPlansLogs () {
    //   // 開啟載入中
    //   this.$root.useLoading()
    //   // 獲得學員點數交易紀錄
    //   // await this.$root.apis.getStudentPointPlans(this.page, this.processStudentPointPlansSuccess, this.processStudentPointPlansError)
    //   // 關閉載入中
    //   this.$root.closeLoading()
    // },
    // // 處理成功回傳的點數交易資料
    // processStudentPointPlansSuccess (_response) {
    //   if (_response.body.error_code !== 0) {
    //     return this.processStudentPointPlansError(_response)
    //   }

    //   // 處理回傳的交易紀錄
    //   let plans = _response.body.data

    //   // 處理資料
    //   this.plans = plans
    // },
    // // 處理失敗回傳的點數交易資料
    // processStudentPointPlansError () {

    // }
  }
}
</script>
<style lang="sass" scoped>
</style>
